import { Button, Text } from '@mantine/core';
import { useHover } from '@mantine/hooks';
import { IconCirclePlus } from '@tabler/icons-react';



type Props = {
    onClick: () => void
}

function NotWorkingButton({ onClick }: Props) {
    const { hovered, ref } = useHover();
    return (
        <Button
            ref={ref}
            variant="default"
            onClick={onClick}
            fullWidth
            bg="gray.1"
        >
            {hovered ? (
                <IconCirclePlus size={20} stroke={1} />
            ) : (
                <Text size="xs" c="dark">
                    کار نمیکنم
                </Text>
            )}

        </Button>
    )
}

export default NotWorkingButton